<template>
    <div class="section pt-2 pb-5">
        <div class="listed-detail mt-1">
            <h3 class="text-center mal-text custom-title">അപേക്ഷകൾ — Verification</h3>
            <p class="text-center text-muted small mb-1" v-if="district_name">{{ district_name }} ജില്ല</p>
        </div>

        <!-- Filters -->
        <div class="card p-2 mb-2" style="border-radius:12px;">
            <select v-model="program_id" class="form-select form-select-sm mb-2" @change="load()">
                <option value="">എല്ലാ പദ്ധതികളും</option>
                <option v-for="p in programs" :key="p.id" :value="p.id">{{ p.title }}</option>
            </select>
            <select v-model="status_filter" class="form-select form-select-sm" @change="load()">
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="verified">Verified</option>
                <option value="not_verified">Not Verified</option>
                <option value="edit_requested">Edit Requested</option>
                <option value="resubmitted">Resubmitted</option>
            </select>
        </div>

        <div class="text-center py-4" v-if="loading"><div class="spinner-border text-primary"></div></div>
        <div v-else-if="!list.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">അപേക്ഷകൾ ഇല്ല</div>

        <router-link v-for="row in list" :key="row.id" :to="'/sneha-sparsham-verification/' + row.id"
            class="d-block text-decoration-none">
            <div class="card mb-2" style="border-radius:12px;">
                <div class="card-body mal-text" style="padding:12px 14px;">
                    <div class="d-flex justify-content-between align-items-start">
                        <h5 class="mb-1 text-primary" style="font-size:15px;">{{ row.name }}</h5>
                        <span class="badge" :class="badgeClass(row.verification_status)">{{ statusLabel(row.verification_status) }}</span>
                    </div>
                    <p class="mb-0 text-muted small">{{ row.program_title }}</p>
                    <p class="mb-0 small">{{ row.unit_name }}<span v-if="row.zone_name"> · {{ row.zone_name }}</span></p>
                    <p class="mb-0 small" v-if="row.contact">ഫോൺ: {{ row.contact }}</p>
                    <p class="mb-0 small text-muted" v-if="row.created_at">തീയതി: {{ row.created_at }}</p>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparshamVerify",
    data() {
        return {
            loading: false,
            list: [],
            programs: [],
            program_id: "",
            status_filter: "all",
            district_name: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("സ്നേഹ സ്പർശം - Verification");
        this.load();
    },
    methods: {
        statusLabel(s) {
            return s === 'verified' ? 'Verified'
                : s === 'not_verified' ? 'Not Verified'
                : s === 'edit_requested' ? 'Edit Requested'
                : s === 'resubmitted' ? 'Resubmitted' : 'Pending';
        },
        badgeClass(s) {
            return s === 'verified' ? 'bg-success'
                : s === 'resubmitted' ? 'bg-info'
                : s === 'pending' || !s ? 'bg-secondary'
                : 'bg-danger';
        },
        load() {
            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-vo-applications", {
                program_id: this.program_id || null,
                status: this.status_filter,
            }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.list = response.data.data.list || [];
                        this.programs = response.data.data.programs || [];
                        this.district_name = response.data.data.district_name || "";
                    } else {
                        this.list = [];
                    }
                },
                () => { this.loading = false; }
            );
        },
    },
};
</script>
